import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import { PaymentTransactionsViewModel, Status } from '@usf/payment-types';

@Component({
  selector: 'app-edit-amount-modal',
  templateUrl: './edit-amount-modal.component.html',
  styleUrls: ['./edit-amount-modal.component.scss'],
})
export class EditAmountModalComponent implements OnInit {
  @Input() transactionDetails: PaymentTransactionsViewModel;
  newAmount: number;
  Status = Status;

  constructor(
    private modalController: ModalController,
    public platformService: PlatformService,
  ) {}
  ngOnInit(): void {
    this.newAmount = this.transactionDetails.paymentAmount;
  }

  async closeModal() {
    await this.modalController.dismiss();
  }

  async submitEditAmountModal() {
    await this.modalController.dismiss({
      paymentAmount: this.newAmount,
    });
  }
}
